// extracted by mini-css-extract-plugin
export default {"container":"Sponsors_container__v9zvK","title":"Sponsors_title__l2cRP","logoGrid":"Sponsors_logoGrid__r8D-4","logo":"Sponsors_logo__gtP87","logoImage":"Sponsors_logoImage__fM4-G"};